// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlAppApi: 'https://myworkbeapi.azurewebsites.net/api/',
  azureSaSUrl: 'https://worbeapps.blob.core.windows.net/task?st=1900-01-01T00%3A00%3A00Z&se=9999-12-31T23%3A59%3A00Z&sp=racwl&sv=2018-03-28&sr=c&sig=e6K9c01DiGbic4LuCIuu5pPaVwu3O8C6PfeFFF7wGpI%3D',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
